module.exports = __webpack_public_path__ + "img/n6.f2cd6f37.png";